import React, { useState } from 'react';
import { array } from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Container, List } from 'semantic-ui-react';
import { Routes } from '../../routing';
import { Formatters } from '../../utils';

const StyledList = styled(List)`
  > article {
    display: flex !important;
    align-items: center;
  }
`;

const ANNOUNCEMTN_PER_PAGE = 3;

const RecentAnnouncements = ({ announcements }) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <Container text>
      <div className="container__inner">
        <h3>Other Recent Announcements</h3>
        <StyledList divided relaxed>
          {announcements
            .slice(0, showAll ? announcements.length : ANNOUNCEMTN_PER_PAGE)
            .map(announcement => (
              <List.Item key={announcement.id} as="article">
                <List.Content>
                  <List.Header
                    as={Link}
                    to={Routes.announcement + `/${announcement.id}`}
                  >
                    {announcement.title}
                  </List.Header>
                  <time
                    dateTime={Formatters.date(
                      announcement.createdAt,
                      'YYYY-MM-DD'
                    )}
                  >
                    {Formatters.date(announcement.createdAt, 'MMMM Do, YYYY')}
                  </time>
                  <List.Description as="small">
                    {announcement.teaser}
                  </List.Description>
                </List.Content>
              </List.Item>
            ))}

          {!showAll &&
            announcements &&
            announcements.length > ANNOUNCEMTN_PER_PAGE && (
              <List.Item align="center">
                <a
                  onClick={() => setShowAll(true)}
                  className="link--boxed text--upper"
                >
                  View More Announcements
                </a>
              </List.Item>
            )}
        </StyledList>
      </div>
    </Container>
  );
};

RecentAnnouncements.propTypes = {
  announcements: array
};

export default RecentAnnouncements;
